import { SET_WR_CONTENT } from './wrActions';

export const defaultState = {
    formId: null,
    isDataFetched: false,
    // 3 fields below will be fully rewritten once content is fetched,
    // but let's keep the structure in default state for completeness' sake
    model: [
        {
            correctResponse: {},
            possibleResponses: [],
            stimulus: { stimulusAudio: '' },
        },
    ],
    practice: [
        {
            correctResponse: {},
            possibleResponses: [],
            stimulus: { stimulusAudio: '' },
        },
    ],
    questions: [
        {
            itemId: null,
            possibleResponses: [],
            stimulus: { stimulusAudio: '' },
        },
    ],
    questionsCount: 0,
    // looks like fields below are no use, but let's keep them listed for just in case
    /*
    grade: null,
    measure: null,
    measureType: null,
    period: null,
    totalItems: {},
    */
};

/**
 * Reformat single RCT Accuracy question item from api call from
 * snake_case to camelCase
 * @param {Object} apiItemContent
 * @returns {Object}
 */
const reformatItemContent = apiItemContent => ({
    possibleResponses: apiItemContent.possible_responses.map(possibleResponse => ({
        id: possibleResponse.response_id,
        text: possibleResponse.response_text,
    })),
    stimulus: {
        stimulusAudio: apiItemContent.stimulus.stimulus_audio,
    },
});

/**
 * Reformat content retrieved from API (snake_case)
 * to the content format we need in front end (camelCase)
 * @param {Object} apiContent
 * @returns {Object}
 */
export const reformatAccuracyContent = apiContent => ({
    correctResponses: apiContent.correct_responses,
    formId: apiContent.form_id,
    grade: apiContent.grade,
    measure: apiContent.measure,
    measureType: apiContent.measure_type,
    period: apiContent.period,
    model: apiContent.model.map(modelItemContent => ({
        ...reformatItemContent(modelItemContent),
        correctResponse: {
            id: modelItemContent.correct_response.id,
        },
    })),
    practice: apiContent.practice.map(practiceItemContent => ({
        ...reformatItemContent(practiceItemContent),
        correctResponse: {
            id: practiceItemContent.correct_response.id,
        },
    })),
    questions: apiContent.questions.map(questionItemContent => ({
        ...reformatItemContent(questionItemContent),
        itemId: questionItemContent.item_id,
    })),
    totalItems: {
        model: apiContent.total_items.model,
        practice: apiContent.total_items.practice,
        questions: apiContent.total_items.questions,
    },
    questionsCount: apiContent.total_items.questions,
});

const wrReducer = (state = defaultState, action) => {
    switch (action.type) {
        case SET_WR_CONTENT: {
            // WR content structure is similar to RCT Accuracy, so no need in different reformat method
            // so, we're just using RCT Accuracy method and picking only fields we need here in WR
            const { formId, model, practice, questions } = reformatAccuracyContent(action.content);
            return {
                isDataFetched: true,
                formId,
                model,
                practice,
                questions,
                questionsCount: questions.length,
            };
        }
        default:
            return state;
    }
};

export default wrReducer;
